/**
 *   Generated file. Do not edit
 */

import { LoraConfig } from './models';
import { TapStreamReader } from '@iotize/tap/client/impl';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { enumKeyOrValueToNumber } from '@iotize/tap/client/impl';

declare module '@iotize/tap/client/impl/lib/frame/tap-stream-core' {
  export interface TapStreamReader {
    readLoraConfig(): LoraConfig;
  }
  export interface TapStreamWriter {
    writeLoraConfig(model: LoraConfig): TapStreamWriter;
  }
}

TapStreamReader.prototype.readLoraConfig = function (): LoraConfig {
  const model: Partial<LoraConfig> = {};

  model.classA = this.readBoolean(1);

  model.classB = this.readBoolean(1);

  model.classC = this.readBoolean(1);

  model.dataLoggingEnabled = this.readBoolean(1);

  model.singlePacketEnabled = this.readBoolean(1);

  return model as LoraConfig;
};

// TapStreamWriter.prototype.write(model: LoraConfig) : TapStreamWriter{
//     return this.writeLoraConfig(model)
// }

TapStreamWriter.prototype.writeLoraConfig = function (
  model: LoraConfig,
): TapStreamWriter {
  this.writeBoolean(model.classA, 1);

  this.writeBoolean(model.classB, 1);

  this.writeBoolean(model.classC, 1);

  this.writeBoolean(model.dataLoggingEnabled, 1);

  this.writeBoolean(model.singlePacketEnabled, 1);

  return this;
};
